import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { Button } from "react-bootstrap";
import classNames from "classnames";
import { getS3Informations } from "../../../../common/environmentProperties";
import { EXPORTS } from "../../../../../utils/data/models";
import { extractQueryParams } from "../../../../../../utils/url";
import { canDownload } from "../../../../common/CanDownload";
import { toast } from "react-toastify";
import * as types from "../../../../../utils/data/dataActionTypes";
import englishTranslations from "../../../../../components/intl/en-CA";
import frenchTranslations from "../../../../../components/intl/fr-CA";
import { FormattedMessage } from "react-intl";
import { downloaderEnums } from "../../../../../utils/downloader/downloaderEnums";
import * as DownloaderTypes from "../../../../../utils/downloader/downloaderActionType";
import { bindActionCreators } from "redux";
import * as downloaderActions from "../../../../../utils/downloader/downloaderActions";
import * as dataActions from "../../../../../utils/data/dataActions";
import { isJsonParsable } from "../../../../../utils/stringUtils";

const S3_BUCKET = getS3Informations();

class GenerateCoverageConfirmationButton extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      languageCode: localStorage.getItem("languageCode") || "en-CA",
    };

    this.billingPeriod = null;
    this.toastId = null;
    this.generateCoverageConfirmations =
      this.generateCoverageConfirmations.bind(this);
  }

  handlePromiseError(
    response,
    expectedSuccessType,
    failedMessage = null,
    description,
  ) {
    if (response.type == expectedSuccessType) {
      return response.payload.data;
    }

    toast.update(this.toastId, {
      render: !!failedMessage ? (
        failedMessage
      ) : (
        <FormattedMessage
          id={"members.error.coverageConfirmations.genericError"}
        />
      ),
      type: toast.TYPE.ERROR,
      autoClose: false,
    });
    this.removeDownloadfromListOfDownloads(description);
  }

  removeDownloadfromListOfDownloads(description) {
    const downloadItem = this.props.currentDownloads.find(
      (element) => element.identifier === description,
    );
    if (downloadItem && downloadItem.path) {
      this.props.downloaderActions.clearOngoing(downloadItem.path);
    }
  }

  buildDescription(clientName) {
    const userLanguage = localStorage.getItem("languageCode") || "en-CA";

    if (userLanguage == "fr-CA") {
      return `${frenchTranslations.downloader.coverageConfirmations}: ${clientName}`;
    }
    return `${englishTranslations.downloader.coverageConfirmations}: ${clientName}`;
  }

  generateCoverageConfirmations() {
    const { checkedMembers, billingPeriod } = this.props;
    const description = this.buildDescription(this.props.clientName);

    if (!canDownload(description, this.props.currentDownloads)) {
      toast(
        <FormattedMessage
          id="downloader.duplicateDownload"
          values={{ file: description, br: <br /> }}
        />,
        {
          type: toast.TYPE.ERROR,
          autoClose: downloaderEnums.AUTO_CLOSE,
        },
      );
      return;
    }

    const path = `/v1/clients/${this.props.clientId}/export-coverage-confirmations`;

    const memberIds = checkedMembers
      .map((member) => {
        if (
          member.startDate === billingPeriod.startDate &&
          member.endDate === billingPeriod.endDate
        ) {
          return member.memberId;
        }
      })
      .filter((memberId) => memberId);
    const coverageConfirmationRequest = {
      startDate: this.props.billingPeriod.startDate,
      endDate: this.props.billingPeriod.endDate,
      members_id: memberIds,
      languageCode: this.state.languageCode,
    };

    this.toastId = toast(<FormattedMessage id={"toast.generation"} />, {
      type: toast.TYPE.INFO,
      autoClose: false,
    });
    this.props.currentDownloads.push({ identifier: description, path: path });

    this.handleGenerateExportConfirmations(
      path,
      coverageConfirmationRequest,
      description,
    );
  }

  handleGenerateExportConfirmations(
    path,
    coverageConfirmationRequest,
    description,
  ) {
    const generateCoverageConfirmationPromise = this.props.dataActions
      .simplePost({
        model: { path: path },
        data: { ...coverageConfirmationRequest },
      })
      .then((response) => {
        return JSON.parse(
          this.handlePromiseError(
            response,
            types.SIMPLE_POST_SUCCESS,
            null,
            description,
          ),
        );
      });

    generateCoverageConfirmationPromise.then((data) => {
      const exportId = data.export_id;

      this.exportCoverageConfirmationsInterval = setInterval(() => {
        this.props.dataActions
          .getDataItem(EXPORTS, exportId, {
            fields: "status,objectName,objectPath,details",
          })
          .then((response) => {
            return this.handlePromiseError(
              response,
              types.GET_DATA_ITEM_SUCCESS,
              null,
              description,
            );
          })
          .then((data) => {
            switch (data.status) {
              case "FAILED": {
                this.removeDownloadfromListOfDownloads(description);
                clearInterval(this.exportCoverageConfirmationsInterval);

                const errorsObj = isJsonParsable(
                  data.details.error.replace(/'/g, '"'),
                );

                if (
                  errorsObj.JSONValid &&
                  !!errorsObj.value.message &&
                  errorsObj.value.message.includes("No member found")
                ) {
                  toast.update(this.toastId, {
                    render: (
                      <FormattedMessage
                        id={"members.error.coverageConfirmations.noMemberFound"}
                      />
                    ),
                    type: toast.TYPE.ERROR,
                    autoClose: false,
                  });
                } else {
                  // Generic error
                  toast.update(this.toastId, {
                    render: (
                      <FormattedMessage
                        id={"members.error.coverageConfirmations.genericError"}
                      />
                    ),
                    type: toast.TYPE.ERROR,
                    autoClose: false,
                  });
                }

                return;
              }

              case "GENERATED": {
                clearInterval(this.exportCoverageConfirmationsInterval);
                const query = {
                  clientMethod: "get_object",
                  objectPath: data.objectPath,
                  objectName: data.objectName,
                  bucketName: S3_BUCKET.exportV2.bucket_name,
                  regionName: S3_BUCKET.exportV2.region_name,
                };

                if (data.details && data.details.state == "WARN") {
                  toast.update(this.toastId, {
                    render: (
                      <FormattedMessage
                        id={
                          "members.warning.coverageConfirmations.genericWarning"
                        }
                      />
                    ),
                    type: toast.TYPE.WARNING,
                    autoClose: true,
                  });
                } else {
                  toast.dismiss(this.toastId);
                }

                this.props.dataActions
                  .getS3DataFile(
                    { ...EXPORTS, path: EXPORTS.signingPath },
                    "",
                    query,
                    null,
                  )
                  .then((response) => {
                    return this.handlePromiseError(
                      response,
                      types.GET_S3_DATA_FILE_SUCCESS,
                      null,
                      description,
                    );
                  })
                  .then((data) => {
                    this.handleDownloadGeneratedFile(
                      description,
                      data.signedUrl,
                    ).then(() => {
                      this.removeDownloadfromListOfDownloads(description);
                    });
                  });

                this.props.clearMembersForConfirmation();
                break;
              }

              default: {
                break;
              }
            }
          });
      }, 3000);
    });
  }

  handleDownloadGeneratedFile(description, signedUrl) {
    const url = signedUrl.substr(0, signedUrl.indexOf("?"));
    const queryParams = extractQueryParams(
      signedUrl.substr(signedUrl.indexOf("?")),
    );

    return this.props.downloaderActions
      .downloadFile(url, description, undefined, queryParams)
      .then((response) => {
        this.handlePromiseError(
          response,
          DownloaderTypes.DOWNLOAD_FILE_SUCCESS,
          null,
          description,
        );
      });
  }

  render() {
    const actionButtonClassNames = classNames({
      "generate-button": !this.props.isMenuItem,
    });

    if (this.props.isMenuItem) {
      return (
        <a
          onClick={this.generateCoverageConfirmations}
          className="coverage-confirmation-menu-item"
        >
          <span className="icon icon-in" />
          {this.props.label}
        </a>
      );
    }

    return (
      <Button
        ref="action"
        className={actionButtonClassNames}
        bsStyle={"primary"}
        bsSize={"xsmall"}
        onClick={this.generateCoverageConfirmations}
        disabled={this.props.disabled}
      >
        {this.props.label}
      </Button>
    );
  }
}

GenerateCoverageConfirmationButton.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  disabled: PropTypes.bool,
  toast: PropTypes.func,
  billingPeriod: PropTypes.object,
  currentDownloads: PropTypes.array,
  dataActions: PropTypes.object,
  clientId: PropTypes.number,
  clientName: PropTypes.string,
  clearMembersForConfirmation: PropTypes.func,
  checkedMembers: PropTypes.array,
  downloaderActions: PropTypes.object,
  isMenuItem: PropTypes.bool,
};

function mapStateToProps(state) {
  const downloads = state.downloader || {};
  const checkedMembers = state.selectedConfirmationMembers || {};

  return {
    currentDownloads: downloads.files || [],
    checkedMembers: checkedMembers.data || [],
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dataActions: bindActionCreators(dataActions, dispatch),
    downloaderActions: bindActionCreators(downloaderActions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GenerateCoverageConfirmationButton);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/members/GenerateCoverageConfirmationButton.js